import { OPEN_ERROR_MODAL, CLOSE_ERROR_MODAL } from '../actions/actionTypes';

const initialState: {opened: boolean, error: any} = {opened: false, error: undefined};

export const errorModalReducer = (state: {opened: boolean, error: any } = initialState, action: any) => {
  switch (action.type) {
    case OPEN_ERROR_MODAL:
      return {
        ...state,
        opened: true,
        error: action.data
      }; 
    case CLOSE_ERROR_MODAL:
      return {
        ...state,
        opened: false
      }; 
    default:
      return state;
  }
};